<template>
    <v-dialog max-width="60%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions>
                <v-btn icon class="ma-1" color="red" @click="onPressDelete" :loading="buttonDelete">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="grey" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>

            <v-card-actions class="ma-0 pa-0">
                <v-autocomplete
                        class="ml-5 mr-5 mb-0"
                        v-model="selectedGroup"
                        dense
                        :items="groups"
                        outlined
                        :item-text="item => item.name"
                        item-value="name"
                        return-object
                        small-chips
                        deletable-chips
                ></v-autocomplete>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0">
                <v-card-text class="grey--text">{{keyId}}</v-card-text>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0">
                <v-card :color="getGroupColor()" width="100%" elevation="0" class="ml-5 mr-5 mb-8 white--text" outlined>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        {{this.keyName}}
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0">
                <v-textarea v-model="valueName"
                            class="ml-5 mr-5 mt-0"
                            label="Value"
                            outlined></v-textarea>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonApply"
                        class="ma-2"
                        color="primary"
                        @click="onPressApply">APPLY
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {LocalizationStoreUtils} from "@/modules/mlocalization/database/LocalizationStoreUtils";

export default {
    name: "l-edit-key-popup",
    props: {},
    data: () => ({
        selectedGroup:null,
        buttonApply: false,
        buttonDelete: false,
        dialog: false,
        keyId: "",
        keyName: "",
        valueName: "",
        group_id: "",
        language: "",
    }),
    computed:{
        localizations(){
            return LocalizationStoreUtils.getLocalizations()
        },
        groups(){
            var final = []
            let groups = LocalizationStoreUtils.getLocalizations().groups
            for (let g in groups){
                final.push({name:groups[g].name, id:g})
            }
            return final
        }
    },
    methods: {
        show(group_id, key_id, key_name, language) {
            this.group_id = group_id
            this.language = language
            this.dialog = true
            this.keyName = key_name
            this.keyId = key_id
            this.selectedGroup = {name:this.localizations.groups[group_id].name, id:group_id}
            this.valueName = this.localizations.keys[key_id][language.name]
        },
        hide() {
            this.dialog = true
        },
        onClose() {
            this.dialog = false
        },
        onPressDelete(){
            this.buttonDelete = true
            LocalizationStoreUtils.deleteKey(this.keyId, this.keyName)
            .then(() => {
                this.buttonDelete = false
                this.dialog = false
                this.$notify({title: 'Item successfully deleted!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.buttonDelete = false
                this.$notify({title: 'Item deleted failed!', text: error, type: "error"});
            })
        },
        onPressApply() {
            if (this.selectedGroup == null){
                this.$notify({title: 'Group Its Empty!', type: "error"});
                return
            }
            if (this.valueName == '' || this.valueName == undefined){
                this.$notify({title: 'Value Its Empty!', type: "error"});
                return
            }
            this.buttonApply = true
            LocalizationStoreUtils.editKeyValue(this.selectedGroup.id, this.keyId, this.keyName, this.language, this.valueName)
                .then(() => {
                    this.buttonApply = false
                    this.dialog = false
                    this.$notify({title: 'Item successfully updated!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.buttonApply = false
                    this.$notify({title: 'Item update failed!', text: error, type: "error"});
                })
        },
        getGroupColor(){
            let data = this.localizations
            for (let g in data.groups){
                if (g == this.group_id){
                    return data.groups[g].color
                }
            }
            return ""
        },
    }
}

</script>

<style scoped>

</style>